import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map } from 'lodash';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import Provider from '../../redux/Provider';
import { updateQuantity, toggleCart } from '../../redux/actions';
import { formatMoney } from '../../slate/currency';
import CartItem from './CartItem';

const moneyFormat = window.theme.moneyFormat;

const PricingRow = ({title, value}) => (
  <div className="pricing-row">
    <span className="pricing-row__title">{title}</span>
    <span className="pricing-row__value">
      {value === 0 ? 'Free' : formatMoney(value, moneyFormat)}
    </span>
  </div>
);

const mapStateToProps = ({ cartShown, cart }) => ({ cartShown, cart });
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ updateQuantity, toggleCart }, dispatch);

class CartContainer extends Component {

  componentWillReceiveProps(nextProps) {
    document.body.classList.toggle('cart-open', nextProps.cartShown);
  }

  componentDidMount() {
    if (window.location.pathname === '/cart') {
      this.props.toggleCart();
    }
  }

  render() {
    const { cart, cartShown, updateQuantity, toggleCart } = this.props;

    return (
      <div className={classnames('cart', { 'cart--is-active': cartShown })}>
        <div className="cart__items">
          <h2 className="cart__heading">
            Order Summary
          </h2>

          {cart.items.map((item, index) => (
            <CartItem
              key={item.id}
              item={item}
              incrementQuantity={() => updateQuantity(index + 1, item.quantity + 1)}
              decrementQuantity={() => updateQuantity(index + 1, item.quantity - 1)}
            />
          ))}
        </div>

        <div className="cart__footer">
          <PricingRow
            title="Total"
            value={cart.total_price}
          />
          <a
            href="/checkout"
            className="cart__footer-checkout-btn"
          >
            Checkout
          </a>

          <button
            className="cart__footer-continue-shopping"
            onClick={toggleCart}
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }
}

export default Provider(
  connect(mapStateToProps, mapDispatchToProps)(CartContainer)
);



// WEBPACK FOOTER //
// ./assets/scripts/components/Cart/CartContainer.js